import React, { useEffect } from 'react'
import { useNavigate} from 'react-router-dom';
import BigAd from '../components/BigAd';
import { HomePath } from '../home-path'
import Median from 'median-js-bridge';

export default function Login() {
    if (!localStorage.getItem('reloadGN')) {
        localStorage.setItem('reloadGN', 'true');
        window.location.reload();
    }

    const navigate = useNavigate();

    useEffect(() => {
        if (window.navigator.userAgent.indexOf("gonative") !== -1) {
            const username = 'gonative';
            const password = 'password';

            Median.auth.status({ callbackFunction: gonative_status_beforelogin });

            function gonative_status_beforelogin(data) {
                if (data && data.hasTouchId && data.hasSecret) {
                    // Prompt the user to use the fingerprint to log in
                    Median.auth.get({ 'callbackFunction': gonative_secret_callback });
                }
            }

            // check auth
            function gonative_secret_callback(data) {
                if (data && data.success && data.secret) {
                    alert("Authentication Successful");
                    // Use username and password to do login here,
                    // e.g. an http post or ajax request
                    var credentials = JSON.parse(data.secret);
                    var cred_username = credentials.username;
                    var cred_password = credentials.password;
                    if (cred_username === username && cred_password === password) {
                        navigate('/mobile-shop/home');
                    }
                } else if (data && data.error) {
                    alert("error: " + data.error);
                    // Allow manual entry
                } else {
                    alert("Authentication Failed");
                    // Allow manual entry
                }
            }
        }
    });

    function loginScript() {
        const username = 'gonative';
        const password = 'password';
        let userName = document.getElementById('username_input').value;
        let userPass = document.getElementById('password_input').value;
        if (userName === username && userPass == password) {
            navigate('/mobile-shop/home');
        } else {
            alert("Incorrect username or password!");
        }
    }
  return (
    <>
    <BigAd route={HomePath + "/discover"} minorHeading="Discover" majorHeading="Members only!" text="Join today to be notified on product launches and future content!!"  buttonText="Read article" dark />
    <div className="min-h-full w-full relative flex md:items-center justify-center ">
        <form className="md:mt-10 h-full md:h-fit py-10 px-5 w-full md:max-w-md mx-auto rounded-lg shadow-md space-y-4 bg-white brightness-110">
            <div className="space-y-2">
                <h3 className="text-xl md:text-2xl font-bold text-gray-700">Sign Up or Login</h3>
                <p className="text-sm md:text-md">Sign Up using username and password or just login using touch biometric</p>
            </div>
            <div>
                <div className="max-w-xs space-y-3">
                    <div className="flex items-center justify-between">
                        <span>Username:</span>
                        <input id='username_input' className="py-1 px-2 border outline-none border-gray-400 focus:border-gray-700 rounded-md" type="text" />
                    </div>
                    <div className="flex items-center justify-between">
                        <span>Password:</span>
                        <input id='password_input' className="py-1 px-2 border outline-none border-gray-400 focus:border-gray-700 rounded-md" type="password" />
                    </div>
                </div>
            </div>
            <div className="w-full">
                <button onClick={() => loginScript()} className="rounded-md block w-full py-3 px-5 font-medium bg-gray-700 text-white cursor-pointer hover:bg-black duration-300">Login</button>
            </div>
        </form>
    </div>
    </>
  )
}
